export default __webpack_public_path__ + "static/media/43995-26389-sacrficeofisaac-abraham-isaac-angel-ram.1200w.tn_.800w.tn_.a9a706df.jpg";